import React, { Component } from 'react';
import useCollapse from 'react-collapsed';


// let scholar = require('google-scholar')



class Publication extends Component {

  constructor(props) {
    super(props);
    // this.handleClick = this.handleClick.bind(this);
  }


// Collapsible() {
//     const { getCollapseProps, getToggleProps, isExpanded } = useCollapse();
// return (
//     <div className="collapsible">
//         <div className="header" {...getToggleProps()}>
//             {isExpanded ? 'Collapse' : 'Expand'}
//         </div>
//         <div {...getCollapseProps()}>
//             <div className="content">
//                 Now you can see the hidden content. <br/><br/>
//                 Click again to hide...
//             </div>
//         </div>
//     </div>
//     );
// }



  render() {

    if(this.props.data){
      var papers = this.props.data.papers.map(function(papers){
        let index = papers.author.indexOf("Jizhizi Li");        
        if(index==0){
          var author_pre = ''
          var author_post =papers.author.substring(index+10, papers.author.length)
        }else{
          var author_pre = papers.author.substring(0,index)
          var author_post =papers.author.substring(index+10, papers.author.length)
        }
        return <div key={papers.title}>
            <h3>{papers.title}{papers.rank}</h3>
            <p className="author">{author_pre}<em className="author_jizhizili">JizhiziLi</em>{author_post}<span>&ensp;&bull;&ensp;</span><em className="pubdate">{papers.date}</em></p>
            <p><a className="pubicon" href={papers.paper_link}><i className="fa fa-pub fa-book"></i></a><a className="pubicon" href={papers.file_link}><i className="fa fa-pub fa-file"></i></a><a className="pubicon" href={papers.github_link}><i className="fab fa-pub fa-github"></i></a></p>
            <p className="tlnr">{papers.tlnr}</p>
        </div>


      })
    }


    return (
      <section id="publication">

      <div className="row publication">

         <div className="three columns header-col">
            <h1><span>Publications</span></h1>
         </div>

         <div className="nine columns main-col">
          {papers}
        </div>
        
    </div>

   </section>
    );

  

  }
}

export default Publication;
